import { reGradeEssay } from "@/api";
import EssayRegradeModal from "@/components/essay/essay_regrade_modal.vue";

export default {
  data() {
    return {
      loadingEssay: false,
      loadingFeedback: false,
    };
  },

  methods: {
    async regrade(essay) {
      this.$egModal.show("essay-regrade-modal", {
        component: EssayRegradeModal,
        props: {
          essay,
        },
      });
    },

    async regradeRequest(essayId, payload = {}) {
      try {
        this.loadingFeedback = true;

        await reGradeEssay(essayId, payload);

        this.$showToastSuccess(this.$t("essays.essayRequeued"), {
          title: this.$t("common.success"),
        });
        this.loadingFeedback = false;
      } catch (error) {
        this.loadingFeedback = false;
      }
    },
  },
};
